import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { Gift, ArrowRight } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";
import { PageHero, Section, Loader } from "@/components/Blocks";
import { RiskNotice } from "@/components/layout/PublicLayout";

const KEY = "mct_ref";

export const saveReferral = (r) => localStorage.setItem(KEY, JSON.stringify({ ...r, at: Date.now() }));
export const getReferral = () => {
  try {
    const r = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!r || Date.now() - r.at > (r.tracking_days || 60) * 864e5) return null;
    return r;
  } catch {
    return null;
  }
};
export const clearReferral = () => localStorage.removeItem(KEY);

export const offerText = (o) => (o.offer_type === "percent" ? `${o.offer_value}% off` : `$${(o.offer_value / 100).toFixed(2)} off`);

export default function ReferralLanding() {
  const { code } = useParams();
  const [sp] = useSearchParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.post("/referrals/click", { code, channel: sp.get("ch") || "link" })
      .then(({ data }) => { setD(data); saveReferral({ code, click_id: data.click_id, tracking_days: data.tracking_days, first_name: data.referrer_first_name }); })
      .catch((e) => setErr(errMsg(e)));
  }, [code, sp]);
  if (err) return <Section><div className="panel p-8" data-testid="referral-invalid"><h1 className="font-display text-4xl font-black uppercase">Link not active</h1><p className="mt-2 text-[#475569]">{err}</p><Link to="/cities" className="btn-gold mt-6">Browse classes</Link></div></Section>;
  if (!d) return <Loader />;
  return (
    <>
      <PageHero eyebrow="You've been invited" title={`${d.referrer_first_name} invited you`} sub={d.greeting || "Join a calm, risk-first classroom course on FX, crypto, metals, indices and stocks."}>
        <div className="mt-8 inline-flex items-center gap-4 rounded-lg border border-[#E0A21B]/40 bg-[#0F2342] p-5" data-testid="referral-offer">
          <Gift size={40} weight="duotone" className="text-[#E0A21B]" />
          <div>
            <div className="font-display text-3xl font-black uppercase text-white">{offerText(d)} your first class</div>
            <div className="text-sm text-white/60">Applied automatically at checkout{d.stacking ? "" : ". Does not combine with other coupons"}. Offer saved for {d.tracking_days} days.</div>
          </div>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/register" className="btn-gold" data-testid="referral-register-btn">Create your free account <ArrowRight /></Link>
          <Link to="/cities" className="btn-ghost-dark" data-testid="referral-browse-btn">Find a class near you</Link>
        </div>
      </PageHero>
      <Section><RiskNotice /><p className="mt-3 text-xs text-[#475569]">See the <Link to="/referral-terms" className="underline">referral terms</Link>.</p></Section>
    </>
  );
}
